<div class="success-message" *ngIf="message.type === 'success'">{{ message.message }}</div>
<div class="error-message" *ngIf="message.type === 'error'">{{ message.message }}</div>
